export default __webpack_public_path__ + "static/media/transparency.00d42d34.png";